import { render, staticRenderFns } from "./refund-rules-detail.vue?vue&type=template&id=bc01fa08&"
import script from "./refund-rules-detail.vue?vue&type=script&lang=js&"
export * from "./refund-rules-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports